import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

interface BetaBadgeProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function BetaBadge({ className, size = 'md' }: BetaBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-widest',
        'bg-gradient-to-r from-primary-500/20 via-ai-500/20 to-primary-500/20',
        'border border-ai-400/40 text-ai-300 shadow-[0_0_12px_rgba(6,182,212,0.25)]',
        size === 'sm' && 'px-2 py-0.5 text-[10px]',
        size === 'md' && 'px-2.5 py-1 text-xs',
        size === 'lg' && 'px-4 py-1.5 text-sm',
        className
      )}
    >
      <Sparkles
        className={cn(
          size === 'sm' && 'w-2.5 h-2.5',
          size === 'md' && 'w-3 h-3',
          size === 'lg' && 'w-4 h-4'
        )}
      />
      Beta
    </span>
  )
}
